import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {AccordionModule} from 'primeng/accordion';
import {EmailValidatorDirective} from './validator/email-validator.directive';
import {IdentityNumberValidatorDirective} from './validator/identity-number-validator.directive';
import {PasswordMatchValidatorDirective} from './validator/password-match-validator.directive';
import {CommonContactComponent} from './contact/contact.component';
import {DropdownModule} from 'primeng/dropdown';
import {CheckboxModule} from 'primeng/checkbox';
import {MultiSelectModule} from 'primeng/multiselect';
import {TableModule} from 'primeng/table';
import {SelectButtonModule} from 'primeng/selectbutton';
import {InputTextModule} from 'primeng/inputtext';
import {DialogModule} from 'primeng/dialog';
import {ToastModule} from 'primeng/toast';
import {FieldsetModule} from 'primeng/fieldset';
import {FileUploadModule} from 'primeng/fileupload';
import {ButtonModule} from 'primeng/button';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {MessagesModule} from 'primeng/messages';
import {CommonAboutComponent} from './about/about.component';
import {CommonMapComponent} from './map/map.component';
import {InputTextareaModule} from 'primeng/inputtextarea';
import {PanelModule} from 'primeng/panel';
import {SpinnerComponent} from './spinner/spinner.component';
import {HeadingPlusComponent} from './elements/heading-plus/heading-plus.component';
import {TwoDigitDecimalNumberDirective} from './directive/two-digit-decimal-number.directive';
import {CommonModule, NgOptimizedImage} from '@angular/common';
import {DataViewLayoutOptionsComponent} from './component/data-view-layout-options.component';
import {CustomDataViewModule} from './component/dataview/dataview';
import {DividerModule} from 'primeng/divider';
import {InputNumberModule} from 'primeng/inputnumber';
import {ReadyForSolarComponent} from './advertisements/ready-for-solar/ready-for-solar.component';
import {ShedSystemComponent} from './systems/residential/shed/shed-system.component';
import {EssentialSystemComponent} from './systems/residential/essential/essential-system.component';
import {CompleteSystemComponent} from './systems/residential/complete/complete-system.component';
import {ComprehensiveSystemComponent} from './systems/residential/comprehensive/comprehensive-system.component';
import {QuoteComponent} from './quote/quote.component';
import {TooltipModule} from 'primeng/tooltip';
import {BlockUIModule} from 'primeng/blockui';
import {BreadcrumbComponent} from './component/breadcrumb/breadcrumb.component';

@NgModule({
    declarations: [
        CommonContactComponent,
        CommonAboutComponent,
        CommonMapComponent,
        EmailValidatorDirective,
        HeadingPlusComponent,
        IdentityNumberValidatorDirective,
        PasswordMatchValidatorDirective,
        SpinnerComponent,
        TwoDigitDecimalNumberDirective,
        DataViewLayoutOptionsComponent,
        ReadyForSolarComponent,
        ShedSystemComponent,
        EssentialSystemComponent,
        CompleteSystemComponent,
        ComprehensiveSystemComponent,
        QuoteComponent,
        BreadcrumbComponent
    ],
    imports: [
        NgOptimizedImage,
        AccordionModule,
        ButtonModule,
        CheckboxModule,
        CustomDataViewModule,
        DialogModule,
        DropdownModule,
        DialogModule,
        FormsModule,
        FieldsetModule,
        FileUploadModule,
        InputTextModule,
        InputTextareaModule,
        MultiSelectModule,
        MessagesModule,
        PanelModule,
        ReactiveFormsModule,
        RouterModule,
        SelectButtonModule,
        ToastModule,
        TableModule,
        CommonModule,
        DividerModule,
        InputNumberModule,
        ButtonModule,
        ButtonModule,
        TooltipModule,
        BlockUIModule
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    exports: [
        CommonContactComponent,
        CommonAboutComponent,
        CommonMapComponent,
        EmailValidatorDirective,
        HeadingPlusComponent,
        IdentityNumberValidatorDirective,
        PasswordMatchValidatorDirective,
        SpinnerComponent,
        TwoDigitDecimalNumberDirective,
        DataViewLayoutOptionsComponent,
        ReadyForSolarComponent,
        ShedSystemComponent,
        EssentialSystemComponent,
        CompleteSystemComponent,
        ComprehensiveSystemComponent,
        QuoteComponent,
        BreadcrumbComponent
    ],
    providers: []
})
export class AppCommonModule {
}
